module.exports = __webpack_public_path__ + "static/postcardSample1-01311b911045f0406eb1f83114a5d88b.jpg";